import axios from "axios";
import { Form } from "devextreme-react";
import React, { useEffect, useRef } from "react";
import { notifyMsg } from "./common/notify";
import {
  ButtonItem,
  CompareRule,
  CustomRule,
  EmailRule,
  Label,
  RequiredRule,
  SimpleItem,
} from "devextreme-react/form";

import { ReactComponent as BeccoCRO } from "./BeccoCRO logo_innershadow.svg";

import "./login.css";
import { getRandomInt } from "./common/math";

export default function ChangePassword(props) {
  const { changeExistingPassword, setChangeExistingPassword } = props;

  const formChangePasswordRef = useRef(null);

  useEffect(() => {
    const random = getRandomInt(0, 2);
    const imageType = random === 0 ? 'png' : 'gif';
    const imageNumber = random === 0 ? getRandomInt(0, 432) : getRandomInt(0, 267);
    const imagePath = `/BeTreeImg/${imageType}/${imageNumber}.${imageType}`;

    document.getElementById(
      "random"
    ).style.backgroundImage = `url(${imagePath})`;
  }, []);

  const passwordComparison = () => {
    return formChangePasswordRef.current.instance.option("formData")
      .newPassword;
  };

  const onClickChangePassword = () => {
    if (formChangePasswordRef.current.instance.validate().isValid) {
      const formData =
        formChangePasswordRef.current.instance.option("formData");

      // const email = formLoginRef.current.instance.option("formData").email;

      axios
        .put(`${process.env.REACT_APP_BECCO_API_URL}/api/common/login`, {
          // email: email,
          email: formData.email,
          password: formData.newPassword,
          existingPassword: changeExistingPassword
            ? formData.existingPassword
            : null,
        })
        .then((result) => {
          if (result.data.code == 200) {
            notifyMsg("비밀번호가 변경되었습니다", "success");
            setChangeExistingPassword(false);
          } else {
            // code = 401
            notifyMsg("이메일 또는 기존 비밀번호가 일치하지 않습니다", "error");
          }
        });
    }
  };

  const newPasswordComparison = () => {
    return "becco0401";
  };

  const onClickCancelChangePassword = () => {
    setChangeExistingPassword(false);
  };

  const validationCallback = (e) => {
    if (e.value.length < 8) {
      return false;
    }

    let checkCount = 0;

    if (/[A-Z]/.test(e.value)) {
      checkCount++;
    }

    if (/[a-z]/.test(e.value)) {
      checkCount++;
    }

    if (/[0-9]/.test(e.value)) {
      checkCount++;
    }

    if (/[^A-Za-z0-9]/.test(e.value)) {
      checkCount++;
    }

    if (checkCount < 2) {
      return false;
    }

    if (pwSame(e.value)) {
      return false;
    }

    return true;
  };

  const pwSame = (value) => {
    let tmp = "";
    let cnt = 0;
    const validpw = value;
    for (let i = 0; i < validpw.length; i++) {
      tmp = validpw.charAt(i);
      if (tmp == validpw.charAt(i + 1) && tmp == validpw.charAt(i + 2)) {
        cnt = cnt + 1;
      }
    }
    if (cnt > 0) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <React.Fragment>
      <div className="pwContainer">
        <div className="pic">
          {/* <img src={BeccoCRO} /> */}
          {/* <img src={BeccoCRO3} /> */}
          {/* <img src={BeccoCRO5} /> */}
          {/* <img src={BeccoCRO6} /> */}
          {/* <img src={BeccoCRO7} /> */}
          <img
            id="random"
            // src={require(`./BeTreeImg/${random == 0 ? `png` : `gif`}/${
            //   random == 0
            //     ? getRandomInt(0, 432) + `.png`
            //     : getRandomInt(0, 267) + ".gif"
            // }`)}
          />
        </div>
        <div className="login">
          <form>
            {/* <h1>BeTree</h1>
            <hr /> */}
            <img src="/BeTreeImg/textSvg/3.svg" alt="BeTree Logo" />
            {/* <p /> */}
            {/* <p>Explore the World!</p> */}
            <Form
              id="form-changePassword"
              ref={formChangePasswordRef}
              labelMode="outside"
              showColonAfterLabel={false}
              labelLocation={"top"}
              validationGroup="changePassword"
              // style={{
              //   width: "400px",
              //   display: "block",
              //   margin: "auto",
              //   marginTop: "18px",
              // }}
            >
              <SimpleItem dataField={"email"} editorType="dxTextBox">
                <Label text={"Email"} />
                <RequiredRule message={"Email is required"} />
                <EmailRule message={"Email is invalid"} />
              </SimpleItem>
              {changeExistingPassword && (
                <SimpleItem
                  dataField={"existingPassword"}
                  editorType="dxTextBox"
                  editorOptions={{
                    mode: "password",
                  }}
                >
                  <Label text={"Existing Password"} />
                  <RequiredRule message={"Existing password is required"} />
                </SimpleItem>
              )}

              <SimpleItem
                dataField={"newPassword"}
                editorType="dxTextBox"
                editorOptions={{
                  mode: "password",
                }}
              >
                <Label text={"New Password"} />
                <RequiredRule message={"New password is required"} />
                <CompareRule
                  message={"You cannot register with the default password"}
                  comparisonTarget={newPasswordComparison}
                  comparisonType={"!="}
                />
                <CustomRule
                  validationCallback={validationCallback}
                  message={
                    "영문 대문자, 영문 소문자, 숫자, 특수기호 중 최소 두 가지 이상의 조합을 사용하여 최소 8자리 이상의 문자열을 사용해야 합니다. 세 자리 이상 동일한 문자열 또는 숫자를 사용하면 안됩니다."
                  }
                />
              </SimpleItem>
              <SimpleItem
                dataField={"newPasswordConfirmation"}
                editorType="dxTextBox"
                editorOptions={{
                  mode: "password",
                  onEnterKey: onClickChangePassword,
                }}
              >
                <Label text={"New Password Confirmation"} />
                <RequiredRule message={"Confirm password is required"} />
                <CompareRule
                  message={"Password and confirm password do not match"}
                  comparisonTarget={passwordComparison}
                />
              </SimpleItem>
              <ButtonItem
                horizontalAlignment={"center"}
                verticalAlignment="bottom"
                buttonOptions={{
                  text: "Change",
                  type: "success",
                  width: "100%",
                  onClick: onClickChangePassword,
                }}
                style={{
                  marginLeft: "10px",
                }}
              />
              <ButtonItem
                horizontalAlignment="center"
                verticalAlignment="bottom"
                buttonOptions={{
                  text: "Cancel",
                  type: "normal",
                  width: "100%",
                  stylingMode: "text",
                  onClick: onClickCancelChangePassword,
                }}
              />
            </Form>
            {/*            <label>Email</label>
            <input type="text" placeholder="abc@exampl.com" />
            <label>Password</label>
            <input type="password" placeholder="enter your password!" />
            <button>Start</button>             <p>
              <a href="#">Forgot Password?</a>
            </p>
*/}

            {/* <closeform></closeform> */}
          </form>
        </div>
      </div>
    </React.Fragment>
    // <div style={{ marginTop: 156 }}>
    //   <BeccoCRO
    //     width={420}
    //     height={285.31}
    //     style={{ display: "block", margin: "auto", marginTop: "20px" }}
    //   />
    //   <Form
    //     id="form-changePassword"
    //     ref={formChangePasswordRef}
    //     labelMode="outside"
    //     showColonAfterLabel={false}
    //     labelLocation={"left"}
    //     validationGroup="changePassword"
    //     style={{
    //       width: "400px",
    //       display: "block",
    //       margin: "auto",
    //       marginTop: "18px",
    //     }}
    //   >
    //     <SimpleItem dataField={"email"} editorType="dxTextBox">
    //       <Label text={"아이디 (이메일)"} />
    //       <RequiredRule message={"Email is required"} />
    //       <EmailRule message={"Email is invalid"} />
    //     </SimpleItem>
    //     {changeExistingPassword && (
    //       <SimpleItem
    //         dataField={"existingPassword"}
    //         editorType="dxTextBox"
    //         editorOptions={{
    //           mode: "password",
    //         }}
    //       >
    //         <Label text={"기존 비밀번호"} />
    //         <RequiredRule message={"Existing password is required"} />
    //       </SimpleItem>
    //     )}

    //     <SimpleItem
    //       dataField={"newPassword"}
    //       editorType="dxTextBox"
    //       editorOptions={{
    //         mode: "password",
    //       }}
    //     >
    //       <Label text={"새 비밀번호"} />
    //       <RequiredRule message={"New password is required"} />
    //       <CompareRule
    //         message={"You cannot register with the default password"}
    //         comparisonTarget={newPasswordComparison}
    //         comparisonType={"!="}
    //       />
    //     </SimpleItem>
    //     <SimpleItem
    //       dataField={"newPasswordConfirmation"}
    //       editorType="dxTextBox"
    //       editorOptions={{
    //         mode: "password",
    //         onEnterKey: onClickChangePassword,
    //       }}
    //     >
    //       <Label text={"새 비밀번호 확인"} />
    //       <RequiredRule message={"Confirm password is required"} />
    //       <CompareRule
    //         message={"Password and confirm password do not match"}
    //         comparisonTarget={passwordComparison}
    //       />
    //     </SimpleItem>
    //     <ButtonItem
    //       horizontalAlignment={"center"}
    //       verticalAlignment="bottom"
    //       buttonOptions={{
    //         text: "변경",
    //         type: "success",
    //         width: "100%",
    //         onClick: onClickChangePassword,
    //       }}
    //       style={{
    //         marginLeft: "10px",
    //       }}
    //     />
    //     <ButtonItem
    //       horizontalAlignment="center"
    //       verticalAlignment="bottom"
    //       buttonOptions={{
    //         text: "취소",
    //         type: "normal",
    //         width: "100%",
    //         stylingMode: "text",
    //         onClick: onClickCancelChangePassword,
    //       }}
    //     />
    //   </Form>
    // </div>
  );
}
